import { render } from "./BKZZ.vue?vue&type=template&id=4983eac4&scoped=true"
import script from "./BKZZ.vue?vue&type=script&lang=js"
export * from "./BKZZ.vue?vue&type=script&lang=js"

import "./BKZZ.vue?vue&type=style&index=0&id=4983eac4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4983eac4"]])

export default __exports__